import { Validator } from "./_validator.js";

export class InputValidator extends Validator {
  /**
   * バリデーション実行
   * @returns { void }
   */
  validateRun = () => {
    if (!this.target.classList.contains('is--invalidValidation')) {
      // エラー設定を初期化
      this.initError();

      this.attributeNames.forEach(attributeName => {
        if (this.validationAttributes.includes(attributeName)) {
          const attributeValue = this.target.getAttribute(attributeName);

          if (this.value === '') {
            switch (attributeName) {
              case 'data-required':
                this.#required(attributeValue); // 必須
            }
          }

          if (this.value !== '') {
            switch (attributeName) {
              case 'minlength':
                this.#minlength(attributeValue); // 最小文字数
                break;
              case 'maxlength':
                this.#maxlength(attributeValue); // 最大文字数
                break;
              case 'data-min-num':
                this.#minNum(attributeValue); // 最小値
                break;
              case 'data-max-num':
                this.#maxNum(attributeValue); // 最大値
                break;
              case 'data-full-pitch':
                this.#fullPitch(); // 全角
                break;
              case 'data-full-pitch-kana':
                this.#fullPitchKana(); // 全角カナ
                break;
              case 'data-single-byte-num':
                this.#singleByteNum(); // 半角数字
                break;
              case 'data-single-byte-alphanum':
                this.#singleByteAlphanum(); // 半角英数字
                break;
              case 'data-single-byte-markalphanum':
                this.#singleByteMarkalphanum(); // 半角英数字記号
                break;
              case 'data-minority-digit':
                this.#minorityDigit(attributeValue); // 少数桁
                break;
              case 'data-email':
                this.#email(); // メールアドレス
                break;
              case 'data-email-confirm':
                this.#emailConfirm(attributeValue); // メールアドレス(再確認)
                break;
              case 'data-tel':
                this.#tel(); // 電話番号
                break;
              case 'data-password':
                this.#password(); // パスワード
                break;
              case 'data-password-confirm':
                this.#passwordConfirm(attributeValue); // パスワード(再確認)
                break;
              case 'data-date':
                this.#date(); // 日付
                break;
              case 'data-regex-validation':
                this.#dataRegexValidation(attributeValue); // 正規表現精査
                break;
            }
          }
        }
      });

      this.target.value = this.value;
    } else {
      this.errorCount = 0;
      if (this.target.closest('.js-hide-form') !== null) {
        this.target.value = '';
      }
    }

    // バリデーション結果の反映
    this.resultReflection();
  }

  /**
   * 最小文字数
   * @param { Number } num
   * @returns { void }
   */
  #minlength = (num) => {
    if (this.value.length < Number(num)) {
      this.addErrorCount();
      const maxlength = this.target.getAttribute('maxlength');

      // 数字の場合
      if (this.target.getAttribute('data-single-byte-num') != null) {
        if (maxlength == num) {
          this.setErrorMessage('code000', num);
        } else if (maxlength == null) {
          this.setErrorMessage('code001', num);
        } else {
          this.setErrorMessage('code003', num, maxlength);
        }
      }
      // 全角の場合
      else if (this.target.getAttribute('data-full-pitch') != null) {
        if (maxlength == num) {
          this.setErrorMessage('code004', num);
        } else if (maxlength == null) {
          this.setErrorMessage('code005', num);
        } else {
          this.setErrorMessage('code024', num, maxlength);
        }
      }
      // その他
      else {
        if (maxlength == num) {
          this.setErrorMessage('code025', num);
        } else if (maxlength == null) {
          this.setErrorMessage('code026', num);
        } else {
          this.setErrorMessage('code007', num, maxlength);
        }
      }
    }
  }

  /**
   * 最大文字数
   * @param { Number } num
   * @returns { void }
  */
  #maxlength = (num) => {
    if (this.value.length > Number(num)) {
      this.addErrorCount();
      const minlength = this.target.getAttribute('minlength');

      // 数字の場合
      if (this.target.getAttribute('data-single-byte-num') != null) {
        if (minlength == num) {
          this.setErrorMessage('code000', num);
        } else {
          this.setErrorMessage('code002', num);
        }
      }
      // 全角の場合
      else if (this.target.getAttribute('data-full-pitch') != null) {
        if (minlength == num) {
          this.setErrorMessage('code004', num);
        } else {
          this.setErrorMessage('code006', num);
        }
      }
      // その他
      else {
        if (minlength == num) {
          this.setErrorMessage('code025', num);
        } else {
          this.setErrorMessage('code027', num);
        }
      }
    }
  }

  /**
   * 最小値
   * @param { Number } num
   * @returns { void }
   */
  #minNum = (num) => {
    if (Number(this.value) < Number(num)) {
      this.addErrorCount();
      const maxNum = this.target.getAttribute('data-max-num');

      if (maxNum == null) {
        this.setErrorMessage('code015', num);
      } else {
        this.setErrorMessage('code017', num, maxNum);
      }
    }
  }

  /**
   * 最大値
   * @param { Number } num
   * @returns { void }
   */
  #maxNum = (num) => {
    if (Number(this.value) > Number(num)) {
      this.addErrorCount();
      const minNum = this.target.getAttribute('data-min-num');

      if (minNum == null) {
        this.setErrorMessage('code016', num);
      } else {
        this.setErrorMessage('code017', minNum, num);
      }
    }
  }

  /**
   * 必須
   * @returns { void }
   */
  #required = () => {
    if (this.value.length === 0) {
      this.addErrorCount();

      // select の場合
      if (this.className == 'c-select') {
        this.setErrorMessage('code014');
      }
      // input textarea の場合
      else {
        this.setErrorMessage('code008');
      }
    }
  }

  /**
   * 全角
   * @returns { void }
   */
  #fullPitch = () => {
    if (!this.value.match(/^[^\x01-\x7E\uFF61-\uFF9F]+$/)) {
      this.addErrorCount();
      this.setErrorMessage('code018');
    }
  }

  /**
   * 全角カナ
   * @returns { void }
   */
  #fullPitchKana = () => {
    if (!this.value.match(/^[Ａ-Ｚａ-ｚ０-９，．ァ-ヶ”＃％＆’（）＊＋－／：；＜＝＞？＠￥｜　ー゛゜‐―]*$/)) {
      this.addErrorCount();
      this.setErrorMessage('code019');
    }
  }

  /**
   * 半角数字
   * @returns { void }
   */
  #singleByteNum = () => {
    if (!this.value.match(/^[0-9]+$/)) {
      this.addErrorCount();
      this.setErrorMessage('code020');
    }
  }

  /**
   * 半角英数字
   * @returns { void }
   */
  #singleByteAlphanum = () => {
    if (!this.value.match(/^[0-9a-zA-Z]+$/)) {
      this.addErrorCount();
      this.setErrorMessage('code028');
    }
  }

    /**
   * 半角英数字記号
   * @returns { void }
   */
  #singleByteMarkalphanum = () => {
    if (!this.value.match(/^[A-Za-z0-9! "#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]+$/)) {
      this.addErrorCount();
      this.setErrorMessage('code033');
    }
  }

  /**
   * 少数点を含む数字
   * @returns { void }
   */
  #minorityDigit = (decimalPlaces) => {
    const num = Number(decimalPlaces);
    const regex = new RegExp(`^-?\\d+\\.\\d{${num}}$`);
    if (!this.value.match(regex)) {
      this.addErrorCount();
      this.setErrorMessage('code021', decimalPlaces);
    }
  }

  /**
   * メールアドレス
   * @returns { void }
   */
  #email = () => {
    if (!this.value.match(/^[a-zA-Z0-9_.+-]{1,64}@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/)) {
      this.addErrorCount();
      this.setErrorMessage('code022');
    }
  }

  /**
 * メールアドレス(再確認)
 * @returns { void }
 */
  #emailConfirm = (attributeValue) => {
    if (!this.value.match(/^[a-zA-Z0-9_.+-]{1,64}@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/)) {
      this.addErrorCount();
      this.setErrorMessage('code022');
    } else {
      let tempArrays = attributeValue.split("##");
      let emailConfirmName = tempArrays[0];
      let emailItemName = tempArrays[1];
      let emailItemValue = $('input[name="' + emailItemName + '"]').val();
      if (this.value !== emailItemValue) {
        this.addErrorCount();
        this.setErrorMessage('code031', emailConfirmName);
      }
    }
  }

  /**
   * 電話番号
   * @returns { void }
   */
  #tel = () => {
    if (!this.value.match(/^0\d{1,3}-\d{2,4}-\d{3,4}$/)) {
      this.addErrorCount();
      this.setErrorMessage('code023');
    }
  }

  /**
   * パスワード
   * @returns { void }
   */
  #password = () => {
    let hasLowerUppercase = false;
    let hasDigit = false;
    let hasSymbol = false;
    for (let i = 0; i < this.value.length; i++) {
      if (this.value[i].match(/^[a-z]$/) || this.value[i].match(/^[A-Z]$/)) {
        hasLowerUppercase = true;
      } else if (this.value[i].match(/^[0-9]$/)) {
        hasDigit = true;
      } else if (this.value[i].match(/^[! "#$%&'()*+,-./:;<=>?@[\]^_`{|}~]$/)) {
        hasSymbol = true;
      }
    }
    if (!(hasLowerUppercase && hasDigit && hasSymbol)) {
      this.addErrorCount();
      this.setErrorMessage('code030');
    }
  }

  /**
   * パスワード(再確認)
   * @returns { void }
   */
  #passwordConfirm = (attributeValue) => {
    let hasLowerUppercase = false;
    let hasDigit = false;
    let hasSymbol = false;
    for (let i = 0; i < this.value.length; i++) {
      if (this.value[i].match(/^[a-z]$/) || this.value[i].match(/^[A-Z]$/)) {
        hasLowerUppercase = true;
      } else if (this.value[i].match(/^[0-9]$/)) {
        hasDigit = true;
      } else if (this.value[i].match(/^[! "#$%&'()*+,-./:;<=>?@[\]^_`{|}~]$/)) {
        hasSymbol = true;
      }
    }
    if (!(hasLowerUppercase && hasDigit && hasSymbol)) {
      this.addErrorCount();
      this.setErrorMessage('code030');
    } else {
      let tempArrays = attributeValue.split("##");
      let passwordConfirmName = tempArrays[0];
      let passwordItemName = tempArrays[1];
      let passwordItemValue = $('input[name="' + passwordItemName + '"]').val();
      if (this.value !== passwordItemValue) {
        this.addErrorCount();
        this.setErrorMessage('code031', passwordConfirmName);
      }
    }
  }
  
    /**
   * 日付
   * @returns { void }
   */
  #date = () => {
    if (!this.value.match(/^[0-9]{8}$/)) {
      this.addErrorCount();
      this.setErrorMessage('code034');
    } else {
      var year = this.value.slice(0,4);
      var month = this.value.slice(4,6).replace(/^0+/, '');
      var day = this.value.slice(6,8).replace(/^0+/, '');

      var date = new Date(year, month - 1, day);

      if(date.getFullYear() != year || (date.getMonth() + 1) != month || date.getDate() != day){
        this.addErrorCount();
        this.setErrorMessage('code034');
      }
    }
  }

   /**
   * 正規表現精査
   * @returns { void }
   */
 #dataRegexValidation = (attributeValue) => {
  let tempArrays = attributeValue.split("##");
  let errMsg = tempArrays[0];
  let regex =  new RegExp(tempArrays[1].slice(1, -1));
  if(this.value){
    if (!this.value.match(regex)){
        this.addErrorCount();
        this.setErrorMessage('code032', errMsg);
        return;
    }
  }
}
}
